module.exports = __webpack_public_path__ + "c_static/img/账户体检.ff73832.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/截图示范/账户体检.png
// module id = lguT
// module chunks = 33